"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Urls = void 0;
exports.Urls = {
    counter: {
        prefix: 'counter',
        walkIn: '/walkIn',
        printTicket: '/printTicket',
        addComment: '/addComment',
        backToAppointments: '/backToAppointments',
        backToQueue: '/backToQueue',
        bookAppointment: '/bookAppointment',
        updateAppointment: '/updateAppointment',
        confirmAppointment: '/confirmAppointment',
        finishProcessing: '/finishProcessing',
        inviteAppointment: '/inviteAppointment',
        queueInAppointment: '/queueInAppointment',
        rejectAppointment: '/rejectAppointment',
        removeComment: '/removeComment',
        updateFormData: '/updateFormData',
        getMessageCosts: '/getMessageCosts',
        pauseQueue: '/pauseQueue',
        clearQueue: '/clearQueue',
        clearProcessing: '/clearProcessing',
    },
    subscriptions: {
        prefix: 'subscriptions',
        cancelSubscription: '/cancelSubscription',
        createStripeCheckoutSession: '/createStripeCheckoutSession',
        onStripeUpdateSubscription: '/onStripeUpdateSubscription',
        onStripeCancelledSubscription: '/onStripeCancelledSubscription',
    },
    admin: {
        prefix: 'admin',
        copyPlace: '/copyPlace',
        sdpConnect: '/sdpConnect',
        sdpDisconnect: '/sdpDisconnect',
        createOrganisation: '/createOrganisation',
        updateOrganisation: '/updateOrganisation',
        declineInvitation: '/declineInvitation',
        acceptInvitation: '/acceptInvitation',
        removeOrgMember: '/removeOrgMember',
        withdrawInvitation: '/withdrawInvitation',
        inviteOrgMember: '/inviteOrgMember',
        updateOrgMember: '/updateOrgMember',
        resentInvite: '/resentInvite',
        migratePlace: '/migratePlace',
        migrateTickets: '/migrateTickets',
    },
    visitor: {
        prefix: 'visitor',
        walkIn: '/walkIn',
        bookAppointment: '/bookAppointment',
        cancelAppointment: '/cancelAppointment',
        kioskHeartbeat: '/kioskHeartbeat',
        sendVisitorChatMessage: '/sendVisitorChatMessage',
        markChatMessagesRead: '/markChatMessagesRead',
    },
    messaging: {
        prefix: 'messaging',
        onAppointmentEventSendNotifications: '/onAppointmentEventSendNotifications',
    },
    printing: {
        prefix: 'printing',
        onPrintTicket: '/onPrintTicket',
    },
    publicApi: {
        prefix: 'publicApi',
        printing: {
            sdpPull: '/v1/printing/sdp/pull',
        },
    },
};
//# sourceMappingURL=Urls.js.map